import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AddressModel } from '../../../../_models/admin/supplier-interface/address.model';
import { InterfaceData } from '../../../../_models/admin/supplier-interface/interface.data';
import { SupplierInterfaceData } from '../../../../_models/admin/supplier-interface/supplier.interface.data';
import { AdminSupplierInterfaceService } from '../../../../_services/admin/admin-supplier-interface.service';

@Component({
  selector: 'app-default-supplier-interface-settings',
  templateUrl: './default-supplier-interface-settings.component.html',
  styleUrls: ['./default-supplier-interface-settings.component.scss']
})
export class DefaultSupplierInterfaceSettingsComponent implements OnInit {
  @Input() interfaceDataSuppliers: { [key: number]: InterfaceData[] };
  @Input() supplierInterfaceData: SupplierInterfaceData;
  @Output() interfaceDataChanged: EventEmitter<SupplierInterfaceData> = new EventEmitter<SupplierInterfaceData>();

  constructor(
    public adminSupplierInterfaceService: AdminSupplierInterfaceService
  ) { }

  ngOnInit(): void {
  }

}
